<template>
    <section>
        <div id="element2" class="image__artboard__wrapper">

        </div>
        <div class="core__solution__wrapper">
            <div class="container">
                <div class="row">
                    <div class="col-sm-12 col-md-12 col-lg-2 col-xl-2"></div>
                    <div class="col-sm-12 col-md-12 col-lg-8 col-xl-8">
                        <h4>A Dual Core Solution</h4>
                        <div data-aos="fade" data-aos-duration="3000" class="row">
                            <div class="col-6">
                                <div class="title-solution"> OPTIMIZATION FOR <br> E-COMMERCE</div>
                                <div class="text-solution">
                                    A state-of-the-art multi-carrier delivery automation platform applying rule and
                                    knowledge-based algorithms to solve complex logistics and delivery challenges in
                                    real-time to provide the best delivery option
                                </div>
                            </div>
                            <div class="col-6">
                                <div class="title-solution"> EMPOWER BUSINESS DELIVERY CAPABILITIES</div>
                                <div class="text-solution">
                                    A cutting edge delivery platform across your entire delivery ecosystem to build,
                                    operate and manage your fleet and delivery services within days
                                </div>

                            </div>
                            <div class="col-6">
                                <a class="open" @click="servicesModal()">
                                    <span class="open-circle"> + </span>
                                    <span class="open-circle-text"> Learn More</span>
                                </a>
                            </div>

                            <div class="col-6">
                                <a class="open" @click="platformModal()">
                                    <span class="open-circle"> + </span>
                                    <span class="open-circle-text"> Learn More</span>
                                </a>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-12 col-md-12 col-lg-2 col-xl-2"></div>
                </div>
            </div>
        </div>
        <ModalServicesComponents v-if="showModalServices" @servicesClose="servicesModal()"/>
        <ModalPlatformComponents v-if="showModalPlatform" @servicesClosePlatform="platformModal()"/>
    </section>
</template>

<script>
    import ModalServicesComponents from './ModalServicesComponents.vue'
    import ModalPlatformComponents from './ModalPlatformComponents.vue'

    export default {
        data() {
            return {
                showModalServices: false,
                showModalPlatform: false
            };
        },
        components: {
            ModalServicesComponents,
            ModalPlatformComponents,
        },
        methods: {
            servicesModal() {
                this.showModalServices = !this.showModalServices;
                this.bodyClass(this.showModalServices)
            },
            platformModal() {
                this.showModalPlatform = !this.showModalPlatform;
                this.bodyClass(this.showModalPlatform)
            },
            bodyClass(modal) {
                const body = document.body;
                if (modal) {
                    body.classList.toggle('open');
                } else {
                    body.classList.remove('open');
                }
            }
        }
    }
</script>
